import { render, staticRenderFns } from "./SimpleButton.vue?vue&type=template&id=1fb4e988&scoped=true&"
import script from "./SimpleButton.vue?vue&type=script&lang=ts&"
export * from "./SimpleButton.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleButton.vue?vue&type=style&index=0&id=1fb4e988&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb4e988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
